/* =========================================================
   PLANTIVE PRODUCT GRID - JS (V8.4 - Cart Drawer Integration)
========================================================= */
(function () {
  'use strict';
  const APP_KEY = '__plantiveProductGridV84';

  if (window[APP_KEY]) { window[APP_KEY].scan(document); return; }
  const controllers = new WeakMap();

  function setupSection(section) {
    if (!section || controllers.has(section)) return;

    const swiperContainer = section.querySelector('.ppg-swiper');
    const paginationEl = section.querySelector('.ppg-swiper-pagination');
    const prevButton = section.querySelector('.ppg-mobile-nav-prev');
    const nextButton = section.querySelector('.ppg-mobile-nav-next');
    let swiperInstance = null;
    let swiperWaitTimer = null;
    let swiperWaitCount = 0;
    let stableSnapIndex = 0;
    let pendingBulletIndex = null;

    const layoutD = section.getAttribute('data-layout-d') || 'grid';
    const layoutM = section.getAttribute('data-layout-m') || 'slider';
    const gapD = Number.parseInt(section.getAttribute('data-gap-d'), 10) || 24;
    const gapM = Number.parseInt(section.getAttribute('data-gap-m'), 10) || 16;
    const desktopMedia = window.matchMedia('(min-width: 769px)');

    function setActiveBullet(index) {
      if (!paginationEl) return;
      const bullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
      if (!bullets.length) return;
      const safeIndex = Math.max(0, Math.min(index, bullets.length - 1));
      bullets.forEach((bullet, bulletIndex) => {
        const isActive = bulletIndex === safeIndex;
        bullet.classList.toggle('swiper-pagination-bullet-active', isActive);
      });
    }

    function updateNavButtons(swiper, indexOverride) {
      if (!prevButton || !nextButton) return;
      if (!swiper || swiper.destroyed || !swiper.snapGrid.length) {
        prevButton.disabled = true; nextButton.disabled = true; return;
      }
      const currentIndex = indexOverride ?? swiper.snapIndex ?? 0;
      const lastIndex = Math.max(0, swiper.snapGrid.length - 1);
      prevButton.disabled = currentIndex <= 0;
      nextButton.disabled = currentIndex >= lastIndex;
    }

    function moveToSnap(targetIndex) {
      if (!swiperInstance || swiperInstance.destroyed || swiperInstance.animating) return;
      const lastIndex = Math.max(0, swiperInstance.snapGrid.length - 1);
      const safeIndex = Math.max(0, Math.min(targetIndex, lastIndex));
      if (safeIndex === swiperInstance.snapIndex) return;
      pendingBulletIndex = safeIndex;
      setActiveBullet(safeIndex);
      updateNavButtons(swiperInstance, safeIndex);
      swiperInstance.slideTo(safeIndex, 520);
    }

    function handlePrevClick(e) { e.preventDefault(); e.stopPropagation(); moveToSnap((pendingBulletIndex ?? swiperInstance?.snapIndex ?? stableSnapIndex) - 1); }
    function handleNextClick(e) { e.preventDefault(); e.stopPropagation(); moveToSnap((pendingBulletIndex ?? swiperInstance?.snapIndex ?? stableSnapIndex) + 1); }

    if (prevButton) prevButton.addEventListener('click', handlePrevClick);
    if (nextButton) nextButton.addEventListener('click', handleNextClick);

    function buildPagination(swiper) {
      if (!swiper || swiper.destroyed) return;
      const bulletCount = Math.max(1, swiper.snapGrid.length);
      if (paginationEl) {
        if (paginationEl.children.length !== bulletCount) {
          paginationEl.replaceChildren();
          for (let index = 0; index < bulletCount; index += 1) {
            const bullet = document.createElement('button');
            bullet.type = 'button'; bullet.className = 'swiper-pagination-bullet';
            bullet.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); moveToSnap(index); });
            paginationEl.appendChild(bullet);
          }
        }
        paginationEl.hidden = bulletCount <= 1;
        setActiveBullet(pendingBulletIndex ?? stableSnapIndex);
      }
      updateNavButtons(swiper, pendingBulletIndex ?? stableSnapIndex);
    }

    function commitSettledSlide(swiper) {
      if (!swiper || swiper.destroyed) return;
      stableSnapIndex = Math.max(0, swiper.snapIndex || 0);
      pendingBulletIndex = null;
      setActiveBullet(stableSnapIndex);
      updateNavButtons(swiper, stableSnapIndex);
    }

    function destroySwiper() {
      if (swiperInstance && !swiperInstance.destroyed) { swiperInstance.destroy(true, true); }
      swiperInstance = null; pendingBulletIndex = null;
      if (paginationEl) paginationEl.replaceChildren();
      updateNavButtons(null);
    }

    function createSwiper() {
      if (!swiperContainer || swiperInstance || typeof window.Swiper === 'undefined') return;
      if (swiperContainer.swiper && !swiperContainer.swiper.destroyed) swiperContainer.swiper.destroy(true, true);
      const isDesktop = desktopMedia.matches;
      swiperInstance = new window.Swiper(swiperContainer, {
        initialSlide: stableSnapIndex, slidesPerView: isDesktop ? 3 : 1.2, slidesPerGroup: 1, spaceBetween: isDesktop ? gapD : gapM,
        speed: 520, grabCursor: true, watchOverflow: true, roundLengths: true, resistanceRatio: 0.7,
        on: {
          transitionEnd(swiper) { commitSettledSlide(swiper); },
          slideResetTransitionEnd(swiper) { commitSettledSlide(swiper); },
          snapGridLengthChange(swiper) { buildPagination(swiper); }
        }
      });
      stableSnapIndex = Math.max(0, swiperInstance.snapIndex || 0);
      buildPagination(swiperInstance);
    }

    function applyResponsiveLayout() {
      const currentLayout = desktopMedia.matches ? layoutD : layoutM;
      if (currentLayout !== 'slider') { destroySwiper(); return; }
      if (swiperInstance) destroySwiper();
      createSwiper();
    }

    function waitForSwiper() {
      if (!swiperContainer) return;
      if (typeof window.Swiper !== 'undefined') { applyResponsiveLayout(); return; }
      if (swiperWaitCount >= 100) return;
      swiperWaitCount += 1;
      swiperWaitTimer = window.setTimeout(waitForSwiper, 50);
    }

    desktopMedia.addEventListener('change', applyResponsiveLayout);
    waitForSwiper();

    controllers.set(section, {
      destroy() {
        if (swiperWaitTimer) window.clearTimeout(swiperWaitTimer);
        desktopMedia.removeEventListener('change', applyResponsiveLayout);
        if (prevButton) prevButton.removeEventListener('click', handlePrevClick);
        if (nextButton) nextButton.removeEventListener('click', handleNextClick);
        destroySwiper();
      }
    });

    function getFlavorColor(title) {
      const lower = title.toLowerCase();
      if(lower.includes('ช็อกโกแลต') || lower.includes('chocolate')) return '#4a3018';
      if(lower.includes('มอลต์') || lower.includes('malt')) return '#d4c4b7';
      if(lower.includes('เบอร์รี่') || lower.includes('berry')) return '#8b2846';
      return '#e2e2e2';
    }

    function formatMoney(cents) { return (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' ฿'; }

    const openCards = section.querySelectorAll('.js-open-ppg-modal');
    const modal = section.parentNode.querySelector('.ppg-modal-overlay');
    if(!modal) return;
    
    const closeBtn = modal.querySelector('.ppg-modal-close');
    const flavorsContainer = modal.querySelector('#ppg-m-flavors');
    const btnAddCart = modal.querySelector('#ppg-m-add-cart');
    const btnBuyNow = modal.querySelector('#ppg-m-buy-now');
    const qtyInput = modal.querySelector('#ppg-qty-input');
    const btnMinus = modal.querySelector('#ppg-qty-minus');
    const btnPlus = modal.querySelector('#ppg-qty-plus');
    
    const track = modal.querySelector('#ppg-m-main-track');
    const thumbsContainer = modal.querySelector('#ppg-m-thumbs');
    const btnPrevImg = modal.querySelector('#ppg-m-prev');
    const btnNextImg = modal.querySelector('#ppg-m-next');
    
    const descWrap = modal.querySelector('#ppg-m-desc-wrap');
    const descElem = modal.querySelector('#ppg-m-desc');
    const readMoreBtn = modal.querySelector('#ppg-m-read-more');

    if (readMoreBtn && descElem) {
      readMoreBtn.addEventListener('click', function() {
        if (!descElem.classList.contains('is-expanded')) {
          descElem.style.webkitLineClamp = 'unset'; 
          descElem.style.maxHeight = descElem.scrollHeight + 'px'; 
          descElem.classList.add('is-expanded');
          this.classList.add('is-expanded');
          this.querySelector('span').innerText = 'ย่อเนื้อหา';
          setTimeout(() => { if (descElem.classList.contains('is-expanded')) descElem.style.maxHeight = 'none'; }, 600);
        } else {
          descElem.style.maxHeight = descElem.scrollHeight + 'px'; 
          void descElem.offsetHeight; 
          descElem.style.maxHeight = '68px'; 
          descElem.classList.remove('is-expanded');
          this.classList.remove('is-expanded');
          this.querySelector('span').innerText = 'อ่านเพิ่มเติม';
          setTimeout(() => { if (!descElem.classList.contains('is-expanded')) descElem.style.webkitLineClamp = '3'; }, 600);
        }
      });
    }
    
    let selectedVariantId = null;
    let basePriceRaw = 0; let comparePriceRaw = 0;
    let currentQty = 1;
    let imagesArray = []; let currentImgIndex = 0;

    function updateTotal() {
      const baseTotal = basePriceRaw * currentQty;
      modal.querySelector('#ppg-m-total').innerText = formatMoney(baseTotal);
      
      const compareElem = modal.querySelector('#ppg-m-compare');
      const saveBadge = modal.querySelector('#ppg-m-save-badge');
      
      if (comparePriceRaw > basePriceRaw) {
        const compareTotal = comparePriceRaw * currentQty;
        compareElem.innerText = formatMoney(compareTotal);
        compareElem.style.display = 'inline-block';
        
        const savePercent = Math.round(((compareTotal - baseTotal) / compareTotal) * 100);
        saveBadge.innerText = `ลด ${savePercent}%`;
        saveBadge.style.display = 'inline-block';
      } else {
        compareElem.style.display = 'none'; saveBadge.style.display = 'none';
      }
    }

    function updateGalleryUI() {
      if(imagesArray.length === 0) return;
      track.scrollTo({ left: currentImgIndex * track.clientWidth, behavior: 'smooth' });
      thumbsContainer.querySelectorAll('.ppg-modal-thumb').forEach((t, i) => {
        if(i === currentImgIndex) { t.classList.add('is-active'); t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); } 
        else { t.classList.remove('is-active'); }
      });
      btnPrevImg.style.display = currentImgIndex === 0 ? 'none' : 'flex';
      btnNextImg.style.display = currentImgIndex === imagesArray.length - 1 ? 'none' : 'flex';
    }

    btnPrevImg.addEventListener('click', () => { if(currentImgIndex > 0) { currentImgIndex--; updateGalleryUI(); } });
    btnNextImg.addEventListener('click', () => { if(currentImgIndex < imagesArray.length - 1) { currentImgIndex++; updateGalleryUI(); } });

    openCards.forEach(card => {
      card.addEventListener('click', function(e) {
        if (e.target.closest('.ppg-learn-more')) return; 
        e.preventDefault();
        const data = JSON.parse(this.closest('.ppg-card').querySelector('.ppg-product-json').textContent);
        
        currentQty = 1; qtyInput.value = currentQty;
        selectedVariantId = null;
        basePriceRaw = data.variants.length > 0 ? data.variants[0].price_raw : 0;
        comparePriceRaw = data.variants.length > 0 ? data.variants[0].compare_raw : 0;
        
        imagesArray = data.images || []; currentImgIndex = 0;
        modal.querySelector('#ppg-m-title').innerText = data.title;
        modal.querySelector('#ppg-m-price').innerText = data.variants.length > 0 ? data.variants[0].price_txt : '0 ฿';
        updateTotal();

        if (descWrap && descElem) {
          if (data.desc && data.desc.trim() !== '') {
            descWrap.style.display = 'block';
            descElem.innerHTML = data.desc;
            descElem.classList.remove('is-expanded');
            descElem.style.maxHeight = '68px';
            descElem.style.webkitLineClamp = '3';
            if (readMoreBtn) {
              readMoreBtn.classList.remove('is-expanded');
              readMoreBtn.querySelector('span').innerText = 'อ่านเพิ่มเติม';
              readMoreBtn.style.display = 'none';
              setTimeout(() => { if (descElem.scrollHeight > 72) readMoreBtn.style.display = 'inline-flex'; }, 50);
            }
          } else {
            descWrap.style.display = 'none';
          }
        }

        if(imagesArray.length > 0) {
          let trackHtml = ''; let thumbsHtml = '';
          imagesArray.forEach((imgUrl, idx) => {
            trackHtml += `<img src="${imgUrl}">`;
            thumbsHtml += `<div class="ppg-modal-thumb" data-idx="${idx}"><img src="${imgUrl}"></div>`;
          });
          track.innerHTML = trackHtml; thumbsContainer.innerHTML = thumbsHtml;
          
          thumbsContainer.querySelectorAll('.ppg-modal-thumb').forEach(thumb => {
            thumb.addEventListener('click', function() { currentImgIndex = parseInt(this.getAttribute('data-idx')); updateGalleryUI(); });
          });
          
          track.style.scrollBehavior = 'auto'; track.scrollLeft = 0;
          setTimeout(() => { track.style.scrollBehavior = 'smooth'; }, 50);
          updateGalleryUI();
        } else {
          track.innerHTML = ''; thumbsContainer.innerHTML = '';
          btnPrevImg.style.display = 'none'; btnNextImg.style.display = 'none';
        }

        let html = '';
        data.variants.forEach((v, idx) => {
          const checked = idx === 0 ? 'checked' : '';
          const disabled = !v.available ? 'disabled' : '';
          const txt = !v.available ? `${v.title} (หมด)` : v.title;
          if(idx === 0 && v.available) { selectedVariantId = v.id; basePriceRaw = v.price_raw; comparePriceRaw = v.compare_raw; }
          
          html += `<label><input type="radio" name="ppg_flavor" value="${v.id}" data-price="${v.price_raw}" data-compare="${v.compare_raw}" data-img="${v.image}" class="ppg-flavor-radio" ${checked} ${disabled}>
                   <span class="ppg-flavor-label"><span class="ppg-flavor-label-dot" style="background-color: ${getFlavorColor(v.title)}"></span>${txt}</span></label>`;
        });
        flavorsContainer.innerHTML = html;

        flavorsContainer.querySelectorAll('input').forEach(radio => {
          radio.addEventListener('change', function() { 
            selectedVariantId = this.value; 
            basePriceRaw = parseInt(this.getAttribute('data-price'));
            comparePriceRaw = parseInt(this.getAttribute('data-compare'));
            btnAddCart.disabled = false; btnBuyNow.disabled = false;
            updateTotal();
            const vImg = this.getAttribute('data-img');
            if (vImg && vImg !== 'null') {
              const imgIdx = imagesArray.indexOf(vImg);
              if (imgIdx !== -1) { currentImgIndex = imgIdx; updateGalleryUI(); }
            }
          });
        });

        modal.classList.add('is-active');
      });
    });

    btnMinus.addEventListener('click', () => { if(currentQty > 1) { currentQty--; qtyInput.value = currentQty; updateTotal(); } });
    btnPlus.addEventListener('click', () => { currentQty++; qtyInput.value = currentQty; updateTotal(); });
    closeBtn.addEventListener('click', () => modal.classList.remove('is-active'));
    modal.addEventListener('click', (e) => { if(e.target === modal) modal.classList.remove('is-active'); });

    // 🌟 ฟังก์ชันจัดการปุ่มสั่งซื้อและตะกร้า (อัปเดตใหม่) 🌟
    function handleCartAction(btnElement, isBuyNow) {
      if(!selectedVariantId) return;
      btnElement.disabled = true;
      const originalHtml = btnElement.innerHTML;
      btnElement.innerHTML = "กำลังโหลด...";
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: currentQty }] })
      })
      .then(response => { if (!response.ok) throw response; return response.json(); })
      .then(data => {
        if(isBuyNow) {
          // ถ้ากดสั่งซื้อเลย ให้ตรงไปหน้า Checkout
          window.location.href = window.Shopify.routes.root + 'checkout';
        } else {
          // 🌟 1. ปิดหน้าต่าง Modal ลง
          modal.classList.remove('is-active');
          
          // 🌟 2. ปล่อย Event สั่งให้ Theme (Impulse/Dawn ฯลฯ) ดึงตะกร้าสไลด์ด้านข้างออกมา
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } }));
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
          
          // 🌟 3. คืนค่าปุ่มให้กลับมาเหมือนเดิม เผื่อลูกค้าเปิด Modal เดิมอีกครั้ง
          btnElement.disabled = false;
          btnElement.innerHTML = originalHtml;
        }
      })
      .catch((error) => {
        alert("ไม่สามารถดำเนินการได้ เนื่องจากสินค้าอาจหมดสต็อก");
        btnElement.disabled = false; 
        btnElement.innerHTML = originalHtml; 
      });
    }

    btnAddCart.addEventListener('click', function() { handleCartAction(this, false); });
    btnBuyNow.addEventListener('click', function() { handleCartAction(this, true); });
  }

  function scan(root) {
    if (!root) return;
    if (root.matches && root.matches('.ppg-section')) setupSection(root);
    root.querySelectorAll('.ppg-section').forEach(setupSection);
  }

  const app = { scan };
  window[APP_KEY] = app;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);

  document.addEventListener('shopify:section:load', event => scan(event.target));
})();